import { Injectable } from "@angular/core";
import { HttpRequestService } from "./http-request.service";
import { EndPoints } from "../shared/endpoints.enum";

@Injectable()
export class KwikspaceService {
  constructor(private http: HttpRequestService) { }

  getQuoteList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.QUOTES}${search}${sort}${filter}${page}`
    );
  }

  getCustomerQuoteList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.CUSTOMER_QUOTES}${search}${sort}${filter}${page}`
    );
  }

  getSalesQuoteList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.SALES_QUOTES}${search}${sort}${filter}${page}`
    );
  }

  sendQuoteEmail(quoteId) {
    return this.http.postRequest(
      `${EndPoints.QUOTE_EMAIL}${quoteId}/`,
      quoteId
    );
  }
  
  sendReportEmail() {
    return this.http.postRequest(
      `${EndPoints.REPORT_EMAIL}`, {}
    );
  }

  sendPurchaseQuoteEmail(quoteId) {
    return this.http.postRequest(
      `${EndPoints.PURCHASE_QUOTE_EMAIL}${quoteId}/`,
      quoteId
    );
  }

  getQuoteById(quoteId) {
    return this.http.getAllRequest(`${EndPoints.QUOTES}${quoteId}`);
  }

  downloadQuote(quoteId) {
    return this.http.getByIdRequestBlob(
      `${EndPoints.DOWNLOAD_QUOTE_RENTAL}${quoteId}`
    );
  }

  downloadPurchaseQuote(quoteId) {
    return this.http.getByIdRequestBlob(
      `${EndPoints.DOWNLOAD_QUOTE_PURCHASE}${quoteId}`
    );
  }
  
  emailReportByLocation(location) {
    return this.http.getByIdRequestBlob(
      `${EndPoints.EMAIL_RENTAL_SALES_REPORT}${location}`
    );
  }
  
  emailReportBySalesrep(rep) {
    return this.http.getByIdRequestBlob(
      `${EndPoints.EMAIL_RENTAL_SALES_REPORT_DETAIL}${rep}`
    );
  }

  createQuote(quoteDetails) {
    return this.http.postRequest(EndPoints.QUOTES, quoteDetails);
  }

  updateQuote(quoteDetails, id) {
    return this.http.patchRequest(`${EndPoints.QUOTES}${id}/`, quoteDetails);
  }

  getCustomerList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    return this.http.getAllRequest(
      `${EndPoints.CUSTOMERS}${search}${sort}${page}`
    );
  }

  getCustomerById(custId) {
    return this.http.getAllRequest(`${EndPoints.CUSTOMERS}${custId}`);
  }

  createCustomer(custDetails) {
    return this.http.postRequest(EndPoints.CUSTOMERS, custDetails);
  }

  updateCustomer(custDetails, id) {
    return this.http.putRequest(`${EndPoints.CUSTOMERS}${id}/`, custDetails);
  }

  createCustomerCompany(companyDetails) {
    return this.http.postRequest(EndPoints.COMPANY, companyDetails);
  }

  updateCustomerCompany(companyDetails, id) {
    return this.http.putRequest(`${EndPoints.COMPANY}${id}/`, companyDetails);
  }

  createCustomerAddress(addressDetails) {
    return this.http.postRequest(EndPoints.ADDRESS, addressDetails);
  }

  updateCustomerAddress(addressDetails, id) {
    return this.http.putRequest(`${EndPoints.ADDRESS}${id}/`, addressDetails);
  }

  getNewQuoteRevisionString(quoteReference: string) {
    const revisionNumber = quoteReference.split("Rev0")[1];
    const revisionInt = parseInt(revisionNumber);
    const incrementedRevisionInt = revisionInt + 1;
    return `Rev0${incrementedRevisionInt}`;
  }

  getProductList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    return this.http.getAllRequest(
      `${EndPoints.PRODUCTS}${search}${sort}${page}`
    );
  }

  getPagedProductList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";

    return this.http.getAllRequest(
      `${EndPoints.PRODUCT_LIST}${search}${sort}${page}`
    );
  }

  getTransportChargeOptions() {
    return this.http.getAllRequest(EndPoints.TRANSPORT_CHARGE_OPTIONS);
  }

  getTransportChargeLoad() {
    return this.http.getAllRequest(EndPoints.TRANSPORT_LOADS);
  }

  // getTransportChargeLoadPurchase() {
  //   return this.http.getAllRequest(EndPoints.TRANSPORT_LOADS_PURCHASE);
  // }

  getTransportAreas(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.TRANSPORT_AREAS}${search}${filter}`
    );
  }

  getTransportDistricts(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.TRANSPORT_DISTRICTS}${search}${filter}`
    );
  }

  getTransportChargeConfig(params) {
    const _params = params != null ? params : "";
    return this.http.getAllRequest(`${EndPoints.TRANSPORT_CHARGE}${_params}`);
  }

  getTransportChargeList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.TRANSPORT_CHARGE}${search}${sort}${page}${filter}`
    );
  }

  getDiscountedTransportChargeList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.TRANSPORT_CHARGE_DISCOUNTED}${search}${sort}${page}${filter}`
    );
  }

  createDiscountedTransportCharge(payload) {
    return this.http.postRequest(
      EndPoints.TRANSPORT_CHARGE_DISCOUNTED,
      payload
    );
  }

  updateDiscountedTransportCharge(payload, id) {
    return this.http.putRequest(
      `${EndPoints.TRANSPORT_CHARGE_DISCOUNTED}${id}/`,
      payload
    );
  }

  getRentalPricingList(payload) {
    const search = payload.search ? `?search=${payload.search}` : "";
    const sort = payload.sort ? `?ordering=${payload.sort}` : "";
    const page = payload.page ? `?page=${payload.page}` : "";
    let filter = payload.filter
      ? `?${payload.filter.filterCategory}=${payload.filter.filter}`
      : "";

    if (payload.filter && payload.filter.filterCategory == "clear") {
      filter = "";
    }

    return this.http.getAllRequest(
      `${EndPoints.RENTAL_PRICING}${search}${sort}${page}${filter}`
    );
  }

  getRentalPricing(params) {
    return this.http.getAllRequest(`${EndPoints.RENTAL_PRICING}${params}`);
  }

  getRentalSizes() {
    return this.http.getAllRequest(EndPoints.RENTAL_SIZES);
  }

  getRentalPeriods() {
    return this.http.getAllRequest(EndPoints.RENTAL_PERIODS);
  }

  getRentalOptions() {
    return this.http.getAllRequest(EndPoints.RENTAL_OPTIONS);
  }

  getRentalCategory() {
    return this.http.getAllRequest(EndPoints.RENTAL_CATEGORY);
  }

  getRentalCategorySize(params) {
    return this.http.getAllRequest(
      `${EndPoints.RENTAL_CATEGORY_SIZE}${params}`
    );
  }

  createRentalLineItems(lineItemDetails) {
    return this.http.postRequest(EndPoints.RENTAL_LINE_ITEMS, lineItemDetails);
  }

  updateRentalLineItem(lineItemDetails, id) {
    return this.http.putRequest(
      `${EndPoints.RENTAL_LINE_ITEMS}${id}/`,
      lineItemDetails
    );
  }

  createPurchaseLineItems(lineItemDetails) {
    return this.http.postRequest(
      EndPoints.PURCHASE_LINE_ITEMS,
      lineItemDetails
    );
  }

  updatePurchaseLineItem(lineItemDetails, id) {
    return this.http.putRequest(
      `${EndPoints.PURCHASE_LINE_ITEMS}${id}/`,
      lineItemDetails
    );
  }

  createPurchaseLineItemConfig(lineItemDetails) {
    return this.http.postRequest(EndPoints.ASSET_CONFIG, lineItemDetails);
  }

  getPurchaseSizes() {
    return this.http.getAllRequest(EndPoints.PURCHASE_SIZES);
  }

  getDrawingLayoutDetails() {
    return this.http.getAllRequest(EndPoints.DRAWING_LAYOUT_DETAILS);
  }

  getMatchedPricing(skuList) {
    return this.http.postRequest(EndPoints.PURCHASE_PRODUCT_ASSET_PRICE_MATCH, skuList);
  }

  getProductConfiguration() {
    return this.http.getAllRequest(EndPoints.PRODUCT_CONFIG);
  }

  createProductConfiguration(productDetails) {
    return this.http.postRequest(EndPoints.PRODUCT_CONFIG, productDetails);
  }

  updateProductConfiguration(productDetails, id) {
    return this.http.putRequest(
      `${EndPoints.PRODUCT_CONFIG}${id}/`,
      productDetails
    );
  }

  getSaleLocations() {
    return this.http.getAllRequest(EndPoints.LOCATIONS);
  }

  getQuoteValidities() {
    return this.http.getAllRequest(EndPoints.VALIDITY);
  }

  getSalesReps() {
    return this.http.getAllRequest(EndPoints.SALES_REPS);
  }

  getFloorplannerKey(id) {
    return this.http.getAllRequest(`${EndPoints.FP_USER_KEY}${id}`);
  }

  getFloorPlannerProjectList() {
    return this.http.getAllRequest(EndPoints.FP_PROJECTS);
  }

  getFloorPlannerProject(id) {
    return this.http.getAllRequest(`${EndPoints.FP_PROJECTS}${id}`);
  }

  createFloorplannerProject(projectDetails) {
    return this.http.postRequest(EndPoints.FP_PROJECT, projectDetails);
  }

  createNewDesign(payload) {
    const url = `floorplanner/project/${payload.projectId}/floors/${payload.floorId}/designs/`;
    return this.http.postRequest(url, payload.design);
  }

  getDesign(ids) {
    const url = `floorplanner/project/${ids.projectId}/floors/${ids.floorId}/designs/${ids.designId}/`;
    return this.http.getAllRequest(url);
  }

  getProjectProducts(id) {
    const url = `floorplanner/projects/${id}/products/`;
    return this.http.getAllRequest(url);
  }

  saveProjectProducts(id) {
    const url = `floorplanner/project/${id}/products/`;
    return this.http.postRequest(url, id);
  }

  getFloorPlannerTemplateList() {
    return this.http.getAllRequest(EndPoints.FP_TEMPLATES);
  }

  getFloorPlannerTemplate(id) {
    return this.http.getAllRequest(`${EndPoints.FP_TEMPLATE}${id}`);
  }

  getFloorPlannerProjectDownload(id) {
    return this.http.getAllRequest(`${EndPoints.FP_TEMPLATE}${id}`);
  }

  getFloorPlannerProjectExport(id) {
    return this.http.getAllRequest(`${EndPoints.FP_PROJECT_EXPORT}${id}`);
  }

  exportFloorPlannerProjectFml(payload) {
    return this.http.postRequest(EndPoints.FP_EXPORT_FML, payload);
  }

  exportFloorPlannerProjectTwoD(payload) {
    return this.http.postRequest(EndPoints.FP_EXPORT_TWO, payload);
  }

  exportFloorPlannerProjectThreeD(payload) {
    return this.http.postRequest(EndPoints.FP_EXPORT_THREE, payload);
  }

  getProvinces() {
    return this.http.getAllRequest(EndPoints.PROVINCES);
  }

  getBuildings() {
    return this.http.getAllRequest(EndPoints.BUILDINGS);
  }

  getOrganizations() {
    return this.http.getAllRequest(EndPoints.ORGANIZATIONS);
  }

  getFpProjectCategories() {
    return this.http.getAllRequest(EndPoints.FP_PROJECT_CATEGORIES);
  }

  getFpProjectSubCategories(payload) {
    const category = payload.category ? payload.category : "";
    return this.http.getAllRequest(
      `${EndPoints.FP_PROJECT_CATEGORY_SIZE}${category}`
    );
  }

  getFpProjectSizes(payload) {
    const category = payload.category ? payload.category : "";
    const sub_category = payload.sub_category ? payload.sub_category : "";
    return this.http.getAllRequest(
      `${EndPoints.FP_PROJECT_CATEGORY_SIZE}${category}${sub_category}`
    );
  }

  getFpProjectExtras() {
    return this.http.getAllRequest(EndPoints.FP_PROJECT_EXTRAS);
  }

  getFpProjectCategorySize(params) {
    return this.http.getAllRequest(
      `${EndPoints.FP_PROJECT_CATEGORY_SIZE}${params}`
    );
  }

  getFpProjectPriceList(payload) {
    const category = payload.category ? payload.category : "";
    const sub_category = payload.sub_category ? payload.sub_category : "";
    const size = payload.size ? payload.size : "";
    const variation = payload.variation ? payload.variation : "";
    return this.http.getAllRequest(
      `${EndPoints.FP_PROJECT_PRICE_LIST}${category}${sub_category}${size}${variation}`
    );
  }

  getFpProjectList(payload) {
    const category = payload.category ? payload.category : "";
    const sub_category = payload.sub_category ? payload.sub_category : "";
    const size = payload.size ? payload.size : "";
    const variation = payload.variation ? payload.variation : "";
    return this.http.getAllRequest(
      `${EndPoints.FP_PROJECT_LIST}${category}${sub_category}${size}${variation}`
    );
  }
}
